// LandingCommunityLogsTableVet.jsx
import React, { useEffect, useState } from 'react';
import FunctionsData from "../../../Functions/FunctionsData";
import GeneralTable from "../../../Components/GeneralTable";
import GeneralTableColumn from "../../../Components/GeneralTableColumn";
import VetTableRow from "./VetTableRow";
import { TextField } from "@mui/material";

export default function LandingCommunityLogsTableVet({ account, staffEmail ,targetPortal}) {
  const [search, setSearch] = useState("");
  const [vets, setVets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [hubAdIdsString, setHubAdIdsString] = useState("");
  const [loadingHubAdIds, setLoadingHubAdIds] = useState(true);

  const groupIds = account.idTokenClaims.groups?.join(",") || "";

  // make sure this matches what you use below
  const host = window.location.hostname.toLowerCase();
  let p = "inspectors";
  if (host.includes("community")  ) p = "community";
  else if (host.includes("outreach")) p = "outreach";

  // Fetch the dropdown data and extract hubAdIds
  useEffect(() => {
      setLoadingHubAdIds(true);
      var Portal = "both";
        if(targetPortal.toLowerCase() == 'outreach'){
            Portal= 'outreach';
        }
      FunctionsData.postDataReturn("/api/campaign/hubAdIds", {
          groups: groupIds,
          target: Portal,
      })
          .then((response) => {
              if (Array.isArray(response)) {
                  const ids = response
                      .map((item) => item.id)
                      .filter((id) => id !== undefined && id !== null);
                  const commaSeparatedIds = ids.join(",");
                  setHubAdIdsString(commaSeparatedIds);
              } else {
                  console.error("Unexpected response format:", response);
              }
          })
          .catch((error) => {
              console.error("Error fetching dropdown data:", error);
          })
          .finally(() => setLoadingHubAdIds(false));
  }, [groupIds]);

  // Fetch vets once the hubAdIds lookup has resolved. If the user's groups map
  // to no active campaigns, hubAdIdsString is empty — clear the loading state and
  // show an empty list rather than hanging on "Loading..." forever. Previously the
  // early `return` here left `loading` stuck true whenever hubAdIds came back empty
  // (no matching campaigns / groups), which is why the Vet Clinics tab never
  // finished loading in the outreach portal.
  useEffect(() => {
    if (loadingHubAdIds) return;          // wait until the hubAdIds lookup finishes

    if (!hubAdIdsString) {
      setVets([]);
      setLoading(false);
      return;
    }

    const portal = targetPortal.toLowerCase() === 'outreach'
      ? 'outreach'
      : 'community';

    const url = `/api/voucher/${portal}/staffVet/${hubAdIdsString}`;

    FunctionsData.fetchDataGet(
      url,
      setVets,
      true,
      () => setLoading(false)
    );
  }, [hubAdIdsString, loadingHubAdIds]);

  // useEffect(() => {
  //     FunctionsData.fetchDataGet(
  //         '/api/vet',
  //         setVets, 
  //         true, 
  //         () => setLoading(false)
  //     );
  // }, []);

  useEffect(() => {
      const lowerSearch = search.toLowerCase().trim();
      setFilteredData(vets.filter((vet) => {
          return (
              !search ||
              String(vet.business_name).toLowerCase().includes(lowerSearch) ||
              // String(vet.personal_name).toLowerCase().includes(lowerSearch) ||
              String(vet.formatted_address).toLowerCase().includes(lowerSearch) ||
              String(vet.email).toLowerCase().includes(lowerSearch) ||
              String(vet.phone).toLowerCase().includes(lowerSearch) ||
              String(vet.supplier_website).toLowerCase().includes(lowerSearch) ||
              String(vet.snc_status).toLowerCase().includes(lowerSearch) ||
              String(vet.community_status).toLowerCase().includes(lowerSearch) ||
              String(vet.inspectors_status).toLowerCase().includes(lowerSearch)
          );
      }));
  }, [search, vets]);

  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <TextField
        variant="standard"
        fullWidth
        placeholder="Search"
        sx={{ marginBottom: 2 }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div style={{ overflowX: "auto" }}>
        <GeneralTable asDataTable settingsColumns={`auto `.repeat(p === "outreach" ? 4 : 7)}>
          <GeneralTableColumn header>Business Name</GeneralTableColumn>
          <GeneralTableColumn header>Address</GeneralTableColumn>
          <GeneralTableColumn header>Email</GeneralTableColumn>
          <GeneralTableColumn header>Phone</GeneralTableColumn>
          <GeneralTableColumn header>Website</GeneralTableColumn>

          {p !== "outreach" && (
            <>
              <GeneralTableColumn header>SNC Status</GeneralTableColumn>
              <GeneralTableColumn header>Community Status</GeneralTableColumn>
              <GeneralTableColumn header>Inspector Status</GeneralTableColumn>
            </>
          )}

          {filteredData.map((vet) => (
            <VetTableRow key={vet.id} vet={vet} portal={p} />
          ))}
        </GeneralTable>
        {filteredData.length === 0 && (
          <div style={{ padding: 20, color: "#666" }}>
            No vet clinics found for your campaigns.
          </div>
        )}
      </div>
    </div>
  );
}
